import createIcon from '../../createIcon';

/**
 * @component @name DomainAdd
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgNlYySDFWMjBIMTVWMThIMTFWMTZIMTNWMTRIMTFWMTJIMTNWMTBIMTFWOEgxOVYxNEgyMVY2SDExWk01IDE4SDNWMTZINVYxOFpNNSAxNEgzVjEySDVWMTRaTTUgMTBIM1Y4SDVWMTBaTTUgNkgzVjRINVY2Wk05IDE4SDdWMTZIOVYxOFpNOSAxNEg3VjEySDlWMTRaTTkgMTBIN1Y4SDlWMTBaTTkgNkg3VjRIOVY2Wk0yMyAxOFYyMEgyMVYyMkgxOVYyMEgxN1YxOEgxOVYxNkgyMVYxOEgyM1pNMTcgMTBIMTVWMTJIMTdWMTBaTTE3IDE0SDE1VjE2SDE3VjE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DomainAdd = createIcon('DomainAdd', [
  [
    'path',
    {
      d: 'M11 6V2H1V20H15V18H11V16H13V14H11V12H13V10H11V8H19V14H21V6H11ZM5 18H3V16H5V18ZM5 14H3V12H5V14ZM5 10H3V8H5V10ZM5 6H3V4H5V6ZM9 18H7V16H9V18ZM9 14H7V12H9V14ZM9 10H7V8H9V10ZM9 6H7V4H9V6ZM23 18V20H21V22H19V20H17V18H19V16H21V18H23ZM17 10H15V12H17V10ZM17 14H15V16H17V14Z',
      key: '1ac34d',
    },
  ],
]);

export default DomainAdd;
